import { lazy } from 'react'

// Keeps TinyMCE out of the main bundle; render inside a `Suspense`.
export const LazyHTMLEditor = lazy(() => import('./HTMLEditor').then((module) => ({ default: module.HTMLEditor })))
